import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from '@core/services/admin.service';
import { AppService } from '@core/services/app.service';
import { ErrorHandlerService } from '@core/services/errorHandler/error-handler.service';
import { NgOption } from '@ng-select/ng-select';
import { TranslocoService } from '@ngneat/transloco';
import { AdminSeriesConfig } from '@shared/models/filetype/AdminSeriesConfig';
import { SteuerdatenService } from './steuerdaten.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedSeriesService {
  adminSeriesConfig: AdminSeriesConfig[] = [];
  adminBaureihen!: NgOption[];

  constructor(
    public readonly router: Router,
    public readonly translateService: TranslocoService,
    public readonly adminService: AdminService,
    public readonly appService: AppService,
    public readonly notificationService: ErrorHandlerService,
    private readonly steuerdatenService: SteuerdatenService
  ) {}

  private ValidAsTakSubject = new BehaviorSubject<string[]>([]);
  ValidAsTak$ = this.ValidAsTakSubject.asObservable();

  private ValidversionSubject = new BehaviorSubject<string[]>([]);
  Validversion$ = this.ValidversionSubject.asObservable();

  private importedAstaktSubject = new BehaviorSubject<string>('');
  selectedVersion$ = this.importedAstaktSubject.asObservable();

  setValidAstakt(data: string[]) {
    this.ValidAsTakSubject.next(data);
  }

  setValidversion(data: string[]) {
    this.ValidversionSubject.next(data);
  }
  
  setimportedAstakt(data: string) {
    this.importedAstaktSubject.next(data);
  }
  getAdminSeriesList(): any {
    this.adminService.getSeriesConfig().subscribe(
      (adminSeriesConfig: AdminSeriesConfig[]) => {
        this.adminSeriesConfig = adminSeriesConfig;
        this.adminBaureihen = adminSeriesConfig
          .map(({ brName: brName }) => ({ brName }))
          .sort((br1, br2) => {
            const brName1 = br1.brName;
            const brName2 = br2.brName;
            if (brName1 > brName2) {
              return 1;
            }
            if (brName1 < brName2) {
              return -1;
            }
            return 0;
          });
        setTimeout(() => {
          this.appService.seriesSubject.next(this.adminBaureihen);
        });
      },
      (error: HttpErrorResponse) => {
        this.notificationService.handleServerErrorNotification(
          error,
          'modules.admin-section.config-modal.insert-edit-api-error-message'
        );
      }
    );
    return this.adminBaureihen;
  }

  getAsTaktRequiredForBaureihe(brName: string): boolean {
    const config = this.adminSeriesConfig.find(
      (c) => c.brName.toUpperCase() === brName.toUpperCase()
    );
    return config?.asTaktRequired ?? false;
  }

  public getSeries() {
    return new Promise((resolve, reject) => {
      this.adminService.getSeriesConfig().subscribe(
        (adminSeriesConfig: AdminSeriesConfig[]) => {
          resolve(adminSeriesConfig);
        },
        (error: HttpErrorResponse) => {
          this.notificationService.handleServerErrorNotification(
            error,
            'modules.admin-section.config-modal.insert-edit-api-error-message'
          );
          resolve([])
        }
      );
    })
  }

  public getExtractedSerie(vedocData): string {
    const filteredSerie = `C${
      this.steuerdatenService.extractSerieFromFinVin(
        vedocData && vedocData.fin
      ) ||
      this.steuerdatenService.extractSerieFromFinVin(
        vedocData && vedocData.vin
      )
    }`;
    return filteredSerie;
  }
}
